import { z } from 'zod'

export const BaseReciboFormSchema = {
	fecha_de_compra: z.date().optional(),
	uso_de_cfdi: z.string().optional(),
	forma_de_pago: z.string().optional(),
	monto_total: z
		.union([z.string().transform(x => x.replace(/[^0-9.-]+/g, '')), z.number()])
		.pipe(z.coerce.number().min(0.0001).max(999999999))
		.optional(),
	observaciones: z.string().optional(),
}

export const FaguadalajaraFormSchema = z.object({
	folio_factura: z.string().optional(),
	caja: z.number().optional(),
	num_ticket: z.string().optional(),
	email: z.string().optional(),
	...BaseReciboFormSchema,
})

export const FahorroFormSchema = z.object({
	itu: z.string().optional(),
	...BaseReciboFormSchema,
})

export const FaSimilaresSchema = z.object({
	sucursal: z.string().optional(),
	codigo_barras: z.string().optional(),
	email: z.string().optional(),
	...BaseReciboFormSchema,
})

export const OfficemaxFormSchema = z.object({
	referencia: z.string().optional(),
	...BaseReciboFormSchema,
})

export const CostcoFormSchema = z.object({
	num_ticket: z.string().optional(),
	...BaseReciboFormSchema,
})
